import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import axios, { CancelTokenSource } from 'axios';
import Input from 'components/final-form/Input';
import FormButtonsRow from 'components/layout/FormButtonsRow';
import FormContainer from 'components/layout/FormContainer';
import FormContent from 'components/layout/FormContent';
import PraxFormGrid from 'components/layout/PraxFormGrid';
import _ from 'lodash';
import React, { Component } from 'react';
import { Field, Form as FinalForm, FormRenderProps } from 'react-final-form';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { RouteComponentProps } from 'react-router';
import { Button, Grid } from 'semantic-ui-react';
import { registerTestkit } from 'services/testkitService';
import styled from 'styled-components';
import { PraxTestkitRegistrationRequestDto } from 'ts-types/api.types';
import { isValidBarcode } from 'utils/barcodeUtils';
import { applyStyles } from 'utils/textUtils';

const TestRegistrationStyledDiv = styled.div`

  .form-grid {
    margin: 2rem 0;

    &.ui.grid > .column:not(.row),
    &.ui.grid > .row > .column.misanto-prefix {
      font-size: 1.2rem;
      font-weight: bold;
      text-align: right;
      padding-right: 0;
    }

    .field-error,
    .error {
      color: darkred;
      font-size: 1rem;
    }
  }

  .ui.grid.form-grid > .row {
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
  }

  .ui.grid.form-grid > .column:not(.row):first-child,
  .ui.grid.form-grid > .row > .column:first-child {
    padding-left: 0;
  }

  .ui.grid.form-grid > .column:not(.row):last-child,
  .ui.grid.form-grid > .row > .column:last-child {
    padding-right: 0;
  }

`;

const validBarCode = (value: string) => {
  const required = value ? undefined : "required";
  if (required) {
    return required;
  }

  const validBarcode = isValidBarcode(value);
  return validBarcode ? undefined : "invalidCode";
};

// const mustEqualCode = (value: string, allValues: any) => (value === allValues.code ? undefined : 'mustEqualCode');

interface Props extends RouteComponentProps<any>, AuthConsumerRenderProps, MessageSourceProps {
  interventionBookingId: number,
  onCancel: () => void,
  onSave: () => void,
}

interface State {
  error?: string,
  cancelTokenSource: CancelTokenSource,
}

class AddTestkitCodeModal extends Component<Props, State> {

  private mounted: boolean = false;

  initialFormValues = {
    code: "",
    codeConfirm: ""
  };

  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      error: undefined,
      cancelTokenSource
    };
  }

  componentDidMount(): void {
    this.mounted = true;
  }

  componentWillUnmount(): void {
    this.mounted = false;

    const {cancelTokenSource} = this.state;
    cancelTokenSource && cancelTokenSource.cancel('Operation canceled by user');
  }

  onRegisterTestkit = async (values: any) => {
    const {cancelTokenSource} = this.state;

    const testkitCode = values.code;

    const request: PraxTestkitRegistrationRequestDto = {
      interventionBookingId: this.props.interventionBookingId,
      testkitCode: testkitCode
    }
    this.setState({
      cancelTokenSource
    });

    try {
      await registerTestkit(request, cancelTokenSource);
      this.props.onSave();
    } catch (e) {
      const {getMessage, getMessageWithNamedParams} = this.props;
      let error = getMessage("testKitRegistration.error.general");

      const errorData = e.response.data;
      if (errorData && !_.isEmpty(errorData.violations)) {

        const errorCode = errorData.violations[0].errorCode;
        if ([
          "INVALID_BARCODE",
          "BARCODE_ALREADY_EXISTS",
          "ANOTHER_REGISTERED_TESTKIT_IN_PROGRESS_ALREADY_EXIST"
        ].includes(errorCode)) {
          error = getMessageWithNamedParams(`testkitToken.error.${errorCode}`, {
            code: testkitCode
          });
        }
      }

      this.setState({
        error: error
      });

      return;
    }
  };

  render(): React.ReactNode {

    return (
        <TestRegistrationStyledDiv>
          {this.renderRegisterTestkitForm()}
        </TestRegistrationStyledDiv>
    );
  }

  renderRegisterTestkitForm = (): React.ReactNode => {
    return (
        <FinalForm
            onSubmit={(values) => this.onRegisterTestkit(values)}
            initialValues={this.initialFormValues}
            subscription={{values: true, pristine: true, submitting: true}}
            render={this.renderForm}
        />
    );
  };

  renderForm = ({handleSubmit}: FormRenderProps): React.ReactNode => {

    const {error} = this.state;
    const {getMessage, onCancel} = this.props;

    return (
        <form onSubmit={handleSubmit}>
          <FormContainer>
            <FormContent>
              <PraxFormGrid className="form-grid">
                <Grid.Row>
                  <Grid.Column verticalAlign="middle" width={4}>
                    <label htmlFor="code">{getMessage("testKitRegistration.input.code")}:</label>
                  </Grid.Column>
                  <Grid.Column width={12}>
                    <Field
                        id="code"
                        name="code"
                        component={Input}
                        clearable
                        validate={validBarCode}
                    >
                      {({input, meta}) => (
                          <>
                            <Input
                                // id="code"
                                input={input}
                                className="fluid"
                                /*onPaste={(evt: any) => {
                                  evt.preventDefault();
                                  evt.stopPropagation();
                                }}
                                onDrop={(evt: any) => {
                                  evt.preventDefault();
                                  evt.stopPropagation();
                                }}*/
                                autoComplete="off"
                                meta={meta}
                            />
                            {
                              meta.error && meta.touched &&
                              <span className="field-error">
                                                {getMessage(`testKitRegistration.error.${meta.error}`)}
                                            </span>}
                          </>
                      )}
                    </Field>
                  </Grid.Column>
                </Grid.Row>

                {/*<Grid.Row>
                  <Grid.Column verticalAlign="middle" width={4}>
                    <label
                        htmlFor="codeConfirm">{getMessage("testKitRegistration.input.codeConfirm")}:</label>
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right" className="misanto-prefix">
                    MSNT
                  </Grid.Column>
                  <Grid.Column width={10}>
                    <Field
                        id="codeConfirm"
                        name="codeConfirm"
                        component={Input}
                        clearable
                        validate={mustEqualCode}
                    >
                      {({input, meta}) => (
                          <>
                            <FinalFormInput
                                // id="codeConfirm"
                                input={input}
                                onPaste={(evt: any) => {
                                  evt.preventDefault();
                                  evt.stopPropagation();
                                }}
                                onDrop={(evt: any) => {
                                  evt.preventDefault();
                                  evt.stopPropagation();
                                }}
                                autoComplete="off"
                                meta={meta}
                            />
                            {
                              meta.error && meta.touched &&
                              <span className="field-error">
                                                {getMessage(`testKitRegistration.error.${meta.error}`)}
                                            </span>}
                          </>
                      )}
                    </Field>
                  </Grid.Column>
                </Grid.Row>*/}
                {
                  error &&
                  <Grid.Row className="error">
                    <Grid.Column verticalAlign="middle" width={4}/>
                    <Grid.Column width={12}>
                      {applyStyles(error)}
                    </Grid.Column>
                  </Grid.Row>
                }
              </PraxFormGrid>
            </FormContent>
            <FormButtonsRow>
              <Button
                  compact
                  type="button"
                  floated={"left"}
                  onClick={onCancel}
              >
                {getMessage("button.close")}
              </Button>
              <Button
                  type="submit"
                  className="action-button"
                  primary
                  compact
                  floated={"right"}
                  // onClick={handleSubmit}
              >
                {getMessage("testKitRegistration.action.register")}
              </Button>
            </FormButtonsRow>
          </FormContainer>
        </form>
    );
  };

}

export default withAuthContext(withMessages(AddTestkitCodeModal));
